import React from 'react';
import { useTranslation } from 'react-i18next';
import "./index.css";

export default function Price(props) {
    const { i18n } = useTranslation('appxweb');

    let v = props.children + "";

    if (v === "undefined") {
        return null;
    }

    let dig = Math.floor(v*100) - (Math.floor(v)*100) ;
    let digCode = null;
    let dot = null;

    if (dig > 0) {
        dot = (<span className='tv-price-dot'>{i18n.language === 'fr' ? ',' : '.'}</span>);
        digCode = (<span className='tv-price-dig'>{dig}</span>);
    }

    v = Math.floor(v);

    if (i18n.language === 'fr') {
        return (<span className='tv-price'>{v}{dot}{digCode} <span className='tv-price-sign'>$</span></span>);
    }
    else {
        return (<span className='tv-price'><span className='tv-price-sign'>$</span> {v}{dot}{digCode}</span>);
    }
}
